import { ThunkStatus } from '@wajeez-web/stores/base';
import { Server } from '@wajeez/wajeez.microservices';

export const name = 'common';
export enum Languages {
  // Change this when there is an English version of Wajeez, en = 2
  en = 2,
  ar = 1,
}

export enum Dir {
  RTL = 'rtl',
  LTR = 'ltr',
}
export const localizationSystemValues = {
  ar: {
    key: Languages.ar,
    dir: Dir.RTL,
    name: 'ar',
  },
  en: {
    key: Languages.en,
    dir: Dir.LTR,
    name: 'en',
  },
};

export type SubscriptionType =
  | 'P1Y'
  | 'P1M'
  | 'P1W'
  | 'LIFE_TIME'
  | 'P1S'
  | null;

export type PaymentProduct = Server.ProductGroupProductOutput & {
  promoCode?: string | null;
  pricePrefix?: string | null;
  priceSuffix?: string | null;
  subscriptionType?: SubscriptionType;
};

export interface CommonState {
  alert: AlertState;
  error: ErrorState;
  loading: LoadingState;
  settings: SettingState;
  isSliderMoving?: boolean;
  searchParams?: {
    [key: string]: {
      pathname: string;
      search: { [key: string]: string | null | undefined };
    };
  };
  backNavigation?: {
    pageName: string;
    pathname: string;
    search: { [key: string]: string | null | undefined };
    forwardable?: boolean;
  }[];
  forwardNavigation?: {
    pageName: string;
    pathname: string;
    search: { [key: string]: string | null | undefined };
  }[];
  stripePaymentProduct: PaymentProduct | null | undefined;
}
export interface ErrorState {
  show: boolean;
  type: string | number | null;
}

export interface LoadingState {
  show: boolean;
  ref?: string | null;
  isScreenLoader?: boolean;
}
export interface SettingState {
  navCollapsed: boolean;
  darkMode?: string | null;
  theme: 'base' | 'super-admin' | string | null;
  logo?: string | null;
  innerPageSideBarCollapsed: boolean;
  lang: 'ar' | 'en';
  LanguageId: Languages;
  dir: Dir;
  innerSideBarCollapsed: boolean;
  country: string | null | undefined;
  countryV2: { data: string | null | undefined; status: ThunkStatus };
}
export enum AlertType {
  WARNING,
  SUCCESS,
  ERROR,
  INFO,
}

export interface AlertState {
  show: boolean;
  type: AlertType | null;
  for: 'page' | 'modal';
  messages:
    | { code: number; field: string | null; message: string | null }[]
    | null;
}
